import React, { useEffect, useState } from 'react'
import { Button, Card, Upload, message } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import platformSettingSrc from './platformSettingSrc'

const ALLOWED_LOGO_TYPES = ['image/png', 'image/jpeg']
const MAX_LOGO_SIZE_BYTES = 500 * 1024 // 500KB

function PlatformBrandingCard() {
  const [loginLogo, setLoginLogo] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    platformSettingSrc.getPlatformSettings().then(response => {
      setLoginLogo(response?.login_logo || '')
      setLoading(false)
    })
  }, [])

  const save = logo => {
    platformSettingSrc.updatePlatformSettings({ login_logo: logo }).then(response => {
      if (response?.id) {
        setLoginLogo(logo)
        message.success('Logo de plataforma actualizado')
      } else {
        message.error('No se pudo actualizar el logo de plataforma')
      }
    })
  }

  if (loading) return null

  return (
    <Card title="Marca de la plataforma" style={{ marginBottom: 24 }}>
      <div style={{ color: 'rgba(0, 0, 0, 0.45)', marginBottom: 8 }}>
        Logo que se muestra en la pantalla de inicio de sesión, antes de saber qué empresa va a entrar — es único para toda la plataforma, no por empresa.
      </div>
      <Upload
        accept="image/png,image/jpeg"
        showUploadList={false}
        beforeUpload={file => {
          if (!ALLOWED_LOGO_TYPES.includes(file.type)) {
            message.error('El logo debe ser una imagen PNG o JPG')
            return Upload.LIST_IGNORE
          }
          if (file.size > MAX_LOGO_SIZE_BYTES) {
            message.error('El logo no puede pesar más de 500KB')
            return Upload.LIST_IGNORE
          }

          const reader = new FileReader()
          reader.onload = () => save(reader.result)
          reader.readAsDataURL(file)
          return false
        }}
      >
        <Button icon={<UploadOutlined />}>{loginLogo ? 'Cambiar logo' : 'Subir logo'}</Button>
      </Upload>
      {loginLogo && (
        <div style={{ marginTop: 12 }}>
          <img src={loginLogo} alt="Logo de login" style={{ maxHeight: '80px' }} />
          <div>
            <Button type="link" danger onClick={() => save('')}>Quitar logo</Button>
          </div>
        </div>
      )}
    </Card>
  )
}

export default PlatformBrandingCard
